"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateDismissedNotificationParams () {
        return CreateDismissedNotificationParams;
    },
    get GetDismissedNotificationParams () {
        return GetDismissedNotificationParams;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const GetDismissedNotificationParams = _zod.z.object({
    userId: _utilsisomorphic.transformObjectId,
    notificationId: _utilsisomorphic.transformObjectId
});
const CreateDismissedNotificationParams = _zod.z.object({
    userId: _utilsisomorphic.transformObjectId,
    notificationId: _utilsisomorphic.transformObjectId
});
